var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconImages = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(-105.917 -366.917)" },
                    React.createElement("g", { transform: "translate(107 368)" },
                        React.createElement("path", { d: "M5.7,4.1h10.8c0.8,0,1.5,0.7,1.5,1.5l0,0v10.8c0,0.8-0.7,1.5-1.5,1.5l0,0H5.7\n\t\t\t\tc-0.8,0-1.5-0.7-1.5-1.5l0,0V5.6C4.2,4.8,4.9,4.1,5.7,4.1L5.7,4.1z" })),
                    React.createElement("g", { transform: "translate(112.657 373.785)" },
                        React.createElement("path", { d: "M5.7,17.9h10.8c0.8,0,1.5-0.7,1.5-1.5l0,0V5.6" })),
                    React.createElement("g", { transform: "translate(109.818 370.945)" },
                        React.createElement("path", { d: "M5.7,17.9h10.8c0.8,0,1.5-0.7,1.5-1.5l0,0V5.6" }))),
                React.createElement("path", { strokeWidth: "1.5", d: "M10.3,8.5c0,0.6-0.5,1.1-1.1,1.1S8.1,9.2,8.1,8.5c0-0.6,0.5-1.1,1.1-1.1S10.3,7.9,10.3,8.5\n\t\tL10.3,8.5z" }),
                React.createElement("path", { strokeWidth: "1.5", d: "M18.5,13.4l-3.7-3.7l-8.1,8.1" })))));
});
export default IconImages;
//# sourceMappingURL=IconImages.js.map